import type { EditorImperativeRef } from '@/components/Survey.RichText/interfaces';
import { createNamedContext } from '@trinity/chat-components/utils';

export type RichTextEditorRegistryContextValue = {
  register: (identifier: string, editor: EditorImperativeRef) => void;
  unregister: (identifier: string) => void;
  getEditor: (identifier: string) => EditorImperativeRef;
};

export const RichTextEditorRegistryContext = createNamedContext<RichTextEditorRegistryContextValue>(undefined, 'RichTextEditorRegistryContext');